import { useState, useEffect, MutableRefObject } from 'react'

import styles from '../TechPartnerDashboard/TechPartnerDashboard.module.scss'

import { TechPartnerDashboardInput } from '../TechPartnerDashboard/TechPartnerDashboard'
import { getBaseURL } from '../../GlobalComponents/URLs'

const calculateTopPosition = (elementRef: any) => {
    const rect = elementRef.getBoundingClientRect()
    return rect.bottom - 168
}

interface TechPartnerDashboardNavigationBarProps {
    selectedInputs: TechPartnerDashboardInput
    sectionRefs: {
        section: string
        ref: MutableRefObject<null>
    }[]
}

export const TechPartnerDashboardNavigationBar = ({
    selectedInputs,
    sectionRefs,
}: TechPartnerDashboardNavigationBarProps) => {
    const [selectedVendorId, setSelectedVendorId] = useState<string>('')

    useEffect(() => {
        let newVendorId = ''
        if (selectedInputs.VendorProductCodes) {
            const selectedVendorIds = [
                ...new Set(selectedInputs.VendorProductCodes.map((v) => v.VendorID)),
            ]
            if (selectedVendorIds.length === 1) newVendorId = selectedVendorIds[0]
        }
        setSelectedVendorId(newVendorId)
    }, [selectedInputs.VendorProductCodes])

    const [visibleSection, setVisibleSection] = useState<string>('Main Header')

    useEffect(() => {
        const handleScroll = () => {
            const scrolledTo = window.scrollY + window.innerHeight
            const isReachBottom = document.body.scrollHeight <= scrolledTo

            const selected = sectionRefs.find(({ section, ref }) => {
                const ele = ref.current
                // Check if we are at the bottom
                if (ele) {
                    const positionFromTop = calculateTopPosition(ele)
                    return positionFromTop > 0
                }
            })
            if (selected && isReachBottom) {
                setVisibleSection('Customers')
            } else if (selected && selected.section !== visibleSection) {
                setVisibleSection(selected.section)
            } else {
                setVisibleSection('Main Header')
            }
        }

        if (sectionRefs[sectionRefs.length - 1].ref.current) handleScroll()

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [sectionRefs[sectionRefs.length - 1].ref.current])

    return (
        <div className={`${styles.navSection} hide-on-export`}>
            <div className={`${styles.vendorLogo}`}>
                {selectedVendorId !== '' && (
                    <img
                        src={`${getBaseURL()}InvtForms/VendorLogo.aspx?VendID=${selectedVendorId}`}
                    />
                )}
            </div>
            <div className={`${styles.navButtons}`}>
                <a href='#main-header'>
                    <button
                        className={`${styles.dashboardButton} ${
                            visibleSection === 'Main Header' ? 'selected' : ''
                        }`}
                        onClick={() => {
                            setVisibleSection('Main Header')
                        }}
                    >
                        <div className={`${styles.dashboardIcon} k-icon k-i-paste-plain-text`} />
                        <div>Main Header</div>
                    </button>
                </a>

                <a href='#sales-quota'>
                    <button
                        className={`${styles.dashboardButton} ${
                            visibleSection === 'Sales Plan' ? 'selected' : ''
                        }`}
                        onClick={() => {
                            setVisibleSection('Sales Plan')
                        }}
                    >
                        <div className={`${styles.dashboardIcon} k-icon k-i-graph`} />
                        <div>Sales Plan</div>
                    </button>
                </a>

                <a href='#fulfillment'>
                    <button
                        className={`${styles.dashboardButton} ${
                            visibleSection === 'Fulfillment' ? 'selected' : ''
                        }`}
                        onClick={() => {
                            setVisibleSection('Fulfillment')
                        }}
                    >
                        <div
                            className={`${styles.dashboardIcon} k-icon k-i-track-changes-accept-all`}
                        />
                        <div>Fulfillment</div>
                    </button>
                </a>

                <a href='#market-opportunity'>
                    <button
                        className={`${styles.dashboardButton} ${
                            visibleSection === 'Market Opportunity' ? 'selected' : ''
                        }`}
                        onClick={() => {
                            setVisibleSection('Market Opportunity')
                        }}
                    >
                        <div className={`${styles.dashboardIcon} k-icon k-i-currency`} />
                        <div>Market Opportunity</div>
                    </button>
                </a>

                <a href='#team-resources'>
                    <button
                        className={`${styles.dashboardButton} ${
                            visibleSection === 'Team Resources' ? 'selected' : ''
                        }`}
                        onClick={() => {
                            setVisibleSection('Team Resources')
                        }}
                    >
                        <div className={`${styles.dashboardIcon} k-icon k-i-myspace`} />
                        <div>Team Resources</div>
                    </button>
                </a>

                <a href='#sales-process'>
                    <button
                        className={`${styles.dashboardButton} ${
                            visibleSection === 'Sales Process' ? 'selected' : ''
                        }`}
                        onClick={() => {
                            setVisibleSection('Sales Process')
                        }}
                    >
                        <div className={`${styles.dashboardIcon} k-icon k-i-cart`} />
                        <div>Sales Process</div>
                    </button>
                </a>

                <a href='#customers'>
                    <button
                        className={`${styles.dashboardButton} ${
                            visibleSection === 'Customers' ? 'selected' : ''
                        }`}
                        onClick={() => {
                            setVisibleSection('Customers')
                        }}
                    >
                        <div className={`${styles.dashboardIcon} k-icon k-i-user`} />
                        <div>Customers</div>
                    </button>
                </a>
            </div>
        </div>
    )
}

export default TechPartnerDashboardNavigationBar
